import { render, staticRenderFns } from "./PettyCash.vue?vue&type=template&id=780b4280&scoped=true"
import script from "./PettyCash.vue?vue&type=script&lang=js"
export * from "./PettyCash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780b4280",
  null
  
)

export default component.exports